<template>
  <main class="wrapper-content w-100">
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>Generador de Bandejas de Entradas</h1>
    <b-row>
      <LmTextInput
        label="Nombre de la Bandeja de Entradas"
        placeholder="Nombre de la Bandeja de Entradas"
        class="col-12"
        v-model="inboxSettings.name"
        :v="$v.inboxSettings.name"
      />
    </b-row>
    <h4 class="mb-4">Configuración de la Bandeja de Entrada</h4>
    <b-row>
      <LmTreeSelect
        label="Listado de Widgets"
        class="col-12 mb-4"
        multiple
        :options="widgetsTreeSelectOptions"
        :value="widgetsTreeSelectValue"
        @select="onAddWidget"
        @deselect="onRemoveWidgetFromTreeSelect"
        @input="onRemoveAllWidgets"
      />
      <section class="col-6">
        <draggable
          v-model="inboxWidgets"
          @start="drag=true"
          @end="drag=false"
          animation="150"
          handle=".handle"
          >
          <div v-for="(widget, index) in inboxWidgets" :key="index" class="mb-4">
            <header
              class="d-flex justify-content-between align-items-center shadow rounded-lg text-white bg-primary px-3 handle"
            >
              <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
              <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">
                {{ widgetName(widget) }}
              </h4>
              <div class="d-flex align-items-center">
                <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                <font-awesome-icon
                  v-if="inboxWidgets.length > 1"
                  class="ml-4 clickable"
                  icon="trash"
                  style="width:16px; height:16px;"
                  @click="onRemoveWidget(index)"
                />
              </div>
            </header>
            <b-collapse
              accordion="my-accordion"
              :id="`collapse-${index}`"
              visible
              class="p-4 border border-top-0 rounded-lg"
              >
              <b-row>
                <h5 class="col-12 mb-4">Configuración del widget</h5>
                <LmSelect
                  class="col-4"
                  label="Tamaño"
                  v-model="widget.customization.size"
                  :options="sizeOptions(widget)"
                />
                <LmColorPicker
                  class="col-4"
                  label="Color de fondo"
                  :swatches="swatches"
                  v-model="widget.customization.color"
                />
              </b-row>
            </b-collapse>
          </div>
        </draggable>
      </section>
      <section class="col-6">
        <draggable
          class="row"
          v-model="inboxWidgets"
          @start="drag=true"
          @end="drag=false"
          animation="150"
          handle=".handle"
        >
          <b-col
            class="handle"
            v-for="(widget, index) in inboxWidgets" :key="index"
            :cols="widget.customization.size"
            role="grid"
          >
            <b-card :style="`background-color: ${widget.customization.color}`" v-b-toggle="`collapse-${index}`" role="gridcell">
              <h4>
                <b-badge variant="light" style="white-space: normal;">
                  {{ widgetName(widget) }}
                </b-badge>
              </h4>
            </b-card>
          </b-col>
        </draggable>
      </section>
    </b-row>
    <hr class="w-100">
    <b-row>
      <b-col cols="6">
        <h4 class="mb-4">¿Quiénes verán esta Bandeja de Entradas?</h4>
        <b-row>
          <LmTreeSelect
            label="Áreas"
            class="col-6"
            multiple
            pathToGetOptions="/codificatorbuilder/codificators/60ef327157c5ac23d879c0fb"
            v-model="inboxSettings.areas"
            placeholder="Seleccione las áreas que tendrán acceso"
          />
          <LmTreeSelect
            label="SubÁreas"
            class="col-6"
            multiple
            pathToGetOptions="/codificatorbuilder/codificators/60ef334457c5ac23d879c100"
            v-model="inboxSettings.subareas"
            placeholder="Seleccione las subáreas que tendrán acceso"
          />
          <LmTreeSelect
            label="Roles"
            class="col-12"
            multiple
            pathToGetOptions="/codificatorbuilder/codificators/60ef336657c5ac23d879c105"
            v-model="inboxSettings.roles"
            placeholder="Seleccione los roles que tendrán acceso"
          />
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <LmButton
        buttonClass="btn-secondary"
        class="col-auto"
        :value="$t('cancel')"
        action="cancel"
        @click="$router.push(pathToRedirectBack)"
      />
      <LmButton
        v-if="!inboxSettings.deleted"
        :disabled="!inboxWidgets.length"
        buttonClass="btn-primary"
        class="col-auto"
        :value="$t('save')"
        action="submit"
        @click="onSubmit"
      />
      <LmButton
        v-if="isOnEditMode && !inboxSettings.deleted"
        buttonClass="btn-danger"
        class="col-auto"
        value="Dar de baja"
        action="delete"
        @click="onDelete"
      />
      <LmButton
        v-if="isOnEditMode && inboxSettings.deleted"
        class="col-auto"
        value="Dar de alta"
        action="submit"
        @click="onActivate"
      />
      <p class="col-12 text-danger" v-if="!inboxWidgets.length">Agregar al menos un widget a la bandeja de entradas para guardarla.</p>
    </b-row>
  </main>
</template>

<script>
// Components
import LmSelect from '@/components/form/elements/LmSelect'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'

// Utils
import draggable from 'vuedraggable'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    draggable,
    LmSelect,
    LmButton,
    LmTextInput,
    LmColorPicker,
    LmTreeSelect
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectBack: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      inboxSettings: {
        name: '',
        roles: [],
        areas: [],
        subareas: [],
        deleted: false
      },
      // El inbox con la estructura deseada
      inboxWidgets: [],
      // Necesito los widgets
      widgets: [],
      swatches: [
        ['#F6648B', '#F493A7', '#F891A6', '#FFCCD5'],
        ['#a27bff', '#b99cff', '#d0bdff', '#e8deff'],
        ['#74ebe3', '#96f0ea', '#b9f5f1', '#dcfaf8'],
        ['#ffb748', '#ffc976', '#ffdba3', '#ffedd1'],
        ['']
      ],
      sizes: {
        3: '25%',
        6: '50%',
        9: '75%',
        12: '100%'
      }
    }
  },
  validations: {
    inboxSettings: {
      name: {
        required
      }
    }
  },
  computed: {
    widgetsTreeSelectOptions () {
      return this.widgets.map(el => {
        return {
          name: el.name,
          id: el.id
        }
      })
    },
    widgetsTreeSelectValue () {
      return this.inboxWidgets.map(el => {
        return {
          id: el.widgetId,
          name: this.widgets.find(item => item.id === el.widgetId).name
        }
      })
    }
  },
  methods: {
    widgetName ({ widgetId }) {
      return this.widgets.find(el => el.id === widgetId).name
    },
    sizeOptions ({ widgetId }) {
      const widgets = this.widgets.find(el => el.id === widgetId)
      const options = widgets.properties.sizes.map(size => {
        return {
          value: size,
          text: this.sizes[size]
        }
      })
      return {
        content: options
      }
    },
    showTitleInput (widget) {
      return this.widgets.find(w => w.id === widget.widgetId).component === 'LmList'
    },
    onWidgetIsSelected (event, index) {
      const widgetData = this.widgets.find(el => el.id === event)
      for (const key in this.inboxWidgets.at(index)) {
        this.inboxWidgets.at(index)[key] = widgetData[key]
      }
    },
    onAddWidget (event) {
      const widget = this.widgets.find(el => el.id === event.id)
      const newWidget = {
        widgetId: widget.id,
        customization: {
          size: Math.max.apply(null, widget?.properties?.sizes) || 12,
          color: ''
        }
      }
      this.inboxWidgets.push(newWidget)
    },
    onRemoveWidget (index) {
      this.inboxWidgets.splice(index, 1)
    },
    onRemoveWidgetFromTreeSelect (event) {
      this.inboxWidgets = this.inboxWidgets.filter(el => el.widgetId !== event.id)
    },
    onRemoveAllWidgets (event) {
      if (Array.isArray(event) && !event.length) {
        this.inboxWidgets = []
      }
    },
    async onSubmit () {
      try {
        this.isLoading = true
        await this.validateForm(this.$v)
        if (!this.inboxWidgets.length) {
          throw new Error('Debes cargar al menos un widget en la bandeja de entradas.')
        }
        const dataToSendToServer = {
          widgets: this.inboxWidgets,
          ...this.inboxSettings
        }
        if (this.isOnEditMode) {
          // Edición
          const res = await commonsApi.axiosPutWrapper(`/inbox/${this.$route.params.id}`, dataToSendToServer)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.name || ' la bandeja de entrada'} correctamente.`, 'Se guardó exitosamente')
        } else {
          // Nuevo
          const res = await commonsApi.axiosPostWrapper('/inbox', dataToSendToServer)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.name || ' la bandeja de entrada'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.$router.push(this.pathToRedirectBack)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosPutWrapper(`/inbox/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(`Se dió de baja ${res?.data?.name || ' la bandeja de entrada'} correctamente.`, 'Se dió de baja exitosamente')
        setTimeout(() => {
          this.$router.push(this.pathToRedirectBack)
        }, 650)
      } catch (error) {
        console.log(error)
        this.lmToastDangerMessage(error.message, 'Error')
      } finally {
        this.isLoading = false
      }
    },
    async onActivate () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosPutWrapper(`/inbox/activate/${this.$route.params.id}`)
        this.lmToastSuccessMessage(`Se dió de alta ${res?.data?.name || ' la bandeja de entrada'} correctamente.`, 'Se dió de alta exitosamente')
        setTimeout(() => {
          this.$router.push(this.pathToRedirectBack)
        }, 650)
      } catch (error) {
        console.log(error)
        this.lmToastDangerMessage(error.message, 'Error')
      } finally {
        this.isLoading = false
      }
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Obtengo todos los widgets
      const widgets = await commonsApi.axiosGetWrapper('/widgets/all')
      this.widgets = widgets.data.map(el => {
        return {
          id: el?._id,
          component: el?.component,
          name: el?.name,
          properties: el?.properties
        }
      })
      // Modo Edición
      if (this.isOnEditMode) {
        const inbox = await commonsApi.axiosGetWrapper(`/inbox/${this.$route.params.id}`)
        this.inboxWidgets = inbox?.data?.widgets
        for (const key in this.inboxSettings) {
          if (inbox.data.hasOwnProperty(key)) {
            this.inboxSettings[key] = inbox.data[key]
          }
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
